import React, { useState, useEffect } from 'react';
import { getAllTemplates } from '../../common/templateStore';
import TemplateCard from './TemplateCard';

function TemplatesList() {
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    getAllTemplates()
      .then(setTemplates)
      .catch((err) => console.error(err));
  }, []);

  return (
    <section className="section-padding">
      <div className="container">
        <div className="sec-head mb-80">
          <div className="d-flex align-items-center">
            <div>
              <span className="sub-title main-color mb-5">Hazır Şablonlar</span>
              <h3 className="fw-600 fz-50 text-u d-rotate wow">
                <span className="rotate-text">
                  Web <span className="fw-200">Şablonları.</span>
                </span>
              </h3>
            </div>
          </div>
        </div>

        <div className="row lg-marg">
          {templates.map((item) => (
            <div key={item.id} className="col-lg-4 col-md-6 mb-50">
              <TemplateCard item={item} />
            </div>
          ))}
        </div>

        {templates.length === 0 && (
          <div className="text-center py-80">
            <p className="p-color fz-18">Henüz şablon bulunmuyor.</p>
          </div>
        )}
      </div>
    </section>
  );
}

export default TemplatesList;
